import { Check } from "lucide-react";

const points = [
  {
    title: "Accuracy first",
    desc: "Right animal, right record, every time. EID and visual checks, locked at the point of capture.",
  },
  {
    title: "Faster yard sessions",
    desc: "Less stopping, less rework, more throughput. Crews move with the mob, not against it.",
  },
  {
    title: "Easy onboarding",
    desc: "New staff can use it with minimal training. Big buttons, plain words, no manual required.",
  },
  {
    title: "Works both ways",
    desc: "Use your existing EID reader or fall back to manual entry — dual mode, your call on the day.",
  },
  {
    title: "Real-time reporting",
    desc: "Data builds as you go. Reports are ready when the gate closes — not three days later.",
  },
];

export default function WhyFarmers() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="bg-[#F9F8F6] py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative aspect-[4/5] w-full rounded-md overflow-hidden border border-[#D5D1C8]">
            <img
              src="https://images.pexels.com/photos/31043172/pexels-photo-31043172.jpeg"
              alt="Farmer herding cattle in the yard"
              className="w-full h-full object-cover"
              loading="lazy"
            />
            <div className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-sm border border-[#D5D1C8] rounded-md p-4 shadow-sm">
              <p className="font-display font-bold text-sm text-[#1A1D1A]">
                "Built with farmers and service providers in mind."
              </p>
              <p className="mt-1 text-xs text-[#4A4F4A]">
                Set up for dairy and beef breeding operations.
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-[#D96C32]">
            Why Farmers Use It
          </span>
          <h2
            data-testid="why-headline"
            className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#1A1D1A] leading-tight"
          >
            Built for the yard, not the office.
          </h2>
          <p className="mt-5 text-lg text-[#4A4F4A] leading-relaxed">
            Every decision in Arvo started with a question: does this make the
            session faster, more accurate, or easier on the crew?
          </p>

          <ul className="mt-10 space-y-5">
            {points.map((p) => (
              <li
                key={p.title}
                data-testid={`why-point-${p.title.toLowerCase().replace(/\s/g, "-")}`}
                className="flex gap-4"
              >
                <span className="flex-shrink-0 inline-flex w-8 h-8 items-center justify-center rounded-full bg-[#2D4A22] text-white mt-0.5">
                  <Check className="w-4 h-4" strokeWidth={3} />
                </span>
                <div>
                  <h3 className="font-display font-bold text-lg text-[#1A1D1A]">
                    {p.title}
                  </h3>
                  <p className="mt-1 text-base text-[#4A4F4A] leading-relaxed">
                    {p.desc}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
